export default __webpack_public_path__ + "static/media/z-5.3097bd3c.png";